// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { invoiceDetailSchema } from '@/billing/api/types';
import { DateTime } from 'luxon';
import { z } from 'zod';

const markInvoiceAsSentResponseSchema = z.object({
  data: invoiceDetailSchema,
  metadata: responseMetadataSchema,
});

export interface MarkInvoiceAsSentInput {
  invoiceKey: string;
  sentAt: DateTime;
}

/**
 * Records that an invoice was sent out of band. first_sent_at latches on
 * the first call; subsequent calls only bump last_sent_at.
 */
export async function markInvoiceAsSent(input: MarkInvoiceAsSentInput) {
  const url = `/v1/invoice/${input.invoiceKey}/mark-as-sent`;
  const response = await api.post(url, {
    sentAt: input.sentAt.toUTC().toISO(),
  });

  const result = await parseResponse(
    markInvoiceAsSentResponseSchema,
    response.data,
    {
      schemaName: 'MarkInvoiceAsSent',
      endpoint: url,
    }
  );
  return result.data;
}
